import React from 'react'

import classes from './AssignModal.scss'
import Modal from '../../../../UI/Modal/Modal'
import Spinner from '../../../../UI/Spinner/Spinner'
import Button from '../../../../UI/Button/Button'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import FullWidthTabs from '../../../../UI/Tabs/Tabs'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const assignModal = ({
  loading,
  open,
  cancelled,
  onAssigned,
  assignmentData,
  currentTabIndex,
  tabChanged,
  inputChanged,
  filterInputChanged,
  formIsValid,
  translate
}) => {
  let tabContent = null
  let tableColumns = {}
  let data = null
  let forms = null
  let tabContents = []

  let tabs = Object.entries(assignmentData).map(tab => {
    let [tabKey, tabAttr] = tab

    switch (tabKey) {
      case 'data_access':
        Object.entries(assignmentData[tabKey].columns).map(column => {
          let [columnKey, columnAttr] = column

          let columns = tableColumns[tabKey] || [
            <th key={'label'}>{translate(tabAttr.label) || tabAttr.label}</th>
          ]
          return (tableColumns = {
            ...tableColumns,
            [tabKey]: [
              ...columns,
              columnAttr ? (
                <th key={columnKey}>{translate(columnAttr.label) || columnAttr.label}</th>
              ) : null
            ]
          })
        })

        data = Object.entries(assignmentData[tabKey].data).map(tabData => {
          let [dataKey, dataAttr] = tabData
          let firstColumn = <td>{dataAttr.label}</td>
          let multiSelectRow = null
          let dataColumns = Object.entries(assignmentData[tabKey].columns).map(column => {
            let [columnKey, columnAttr] = column
            let inputSelectStyle = null
            let inputElement = null

            if (columnAttr) {
              inputElement = (
                <InputGroup
                  inputValue={dataAttr.value}
                  inputType={columnAttr.inputType}
                  changed={e =>
                    inputChanged(dataKey, null, columnAttr.inputType, {
                      ...e,
                      code: columnAttr.code
                    })
                  }
                  radioKey={dataKey}
                  radioValue={columnAttr.value}
                  groupClass={classes.InputItem}
                />
              )
            } else {
              return null
            }

            return (
              <td key={`${dataKey + columnKey}`} style={inputSelectStyle}>
                {inputElement}
              </td>
            )
          })

          if (dataAttr.code === 'ACT01') {
            multiSelectRow = (
              <tr>
                <td colSpan={dataColumns.length + 1}>
                  <div className={'IDK'}>
                    <InputGroup
                      label={translate('company')}
                      inputValue={dataAttr.companies.value || []}
                      inputType={'newmultiSelect'}
                      configs={dataAttr?.companies?.elementConfig}
                      changed={e => inputChanged(dataKey, 'companies', 'newmultiSelect', e)}
                      groupClass={classes.InputItem}
                      invalid={!dataAttr.companies.valid}
                      validations={dataAttr.companies.validation}
                      touched={dataAttr.companies.touched}
                      validationError={dataAttr.companies.error}
                    />
                  </div>
                </td>
              </tr>
            )
          } else if (dataAttr.code === 'ACT02') {
            multiSelectRow = (
              <tr>
                <td colSpan={dataColumns.length + 1}>
                  <div className={'IDK'}>
                    <InputGroup
                      label={translate('level')}
                      inputValue={dataAttr.org_level.value || []}
                      inputType={'newselect'}
                      configs={dataAttr.org_level.elementConfig}
                      changed={e => filterInputChanged(e, dataKey, 'level_id', 'orgs')}
                      groupClass={classes.InputItem}
                    />
                    <InputGroup
                      label={translate('organization')}
                      inputValue={dataAttr.orgs.value}
                      inputType={'newmultiSelect'}
                      configs={dataAttr.orgs.elementConfig}
                      changed={e => inputChanged(dataKey, 'orgs', 'newmultiSelect', e)}
                      groupClass={classes.InputItem}
                      invalid={!dataAttr.orgs.valid}
                      validations={dataAttr.orgs.validation}
                      touched={dataAttr.orgs.touched}
                      validationError={dataAttr.orgs.error}
                    />
                  </div>
                </td>
              </tr>
            )
          } else {
            multiSelectRow = null
          }

          return (
            <Aux key={dataKey}>
              <tr key={dataKey}>
                {firstColumn}
                {dataColumns}
              </tr>
              {multiSelectRow}
            </Aux>
          )
        })
        tabContent = (
          <table className={classes.Table}>
            <thead>
              <tr>{tableColumns[tabKey]}</tr>
            </thead>
            <tbody>{data}</tbody>
          </table>
        )
        tabContents.push({
          key: tabKey,
          display: tabContent
        })
        break
      case 'position_group_level_access':
        Object.entries(assignmentData[tabKey].columns).map(column => {
          let [columnKey, columnAttr] = column

          let columns = tableColumns[tabKey] || [
            <th key={'label'} style={{ textAlign: 'left' }}>
              {assignmentData[tabKey].label}
            </th>
          ]
          return (tableColumns = {
            ...tableColumns,
            [tabKey]: [...columns, <th key={columnKey}>{columnAttr.label}</th>]
          })
        })

        data = Object.entries(assignmentData[tabKey].data).map(tabData => {
          let [dataKey, dataAttr] = tabData
          let firstColumn = <td style={{ textAlign: 'left' }}>{dataAttr.label || ''}</td>
          let dataColumns = Object.entries(assignmentData[tabKey].columns).map(column => {
            let [columnKey, columnAttr] = column
            let inputElement = null

            inputElement = (
              <InputGroup
                inputValue={!!dataAttr.checked}
                inputType={columnAttr.inputType}
                changed={e => inputChanged(dataKey, columnKey, columnAttr.inputType, { ...e })}
                groupClass={classes.InputItem}
                inputClass={classes.Checkbox}
                noMargin
                style={{ margin: 0 }}
              />
            )

            return <td key={`${dataKey + columnKey}`}>{inputElement}</td>
          })
          return (
            <tr key={dataKey}>
              {firstColumn}
              {dataColumns}
            </tr>
          )
        })

        tabContent = (
          <table className={classes.Table}>
            <thead>
              <tr>{tableColumns[tabKey]}</tr>
            </thead>
            <tbody>{data}</tbody>
          </table>
        )
        tabContents.push({
          key: tabKey,
          display: tabContent
        })
        break
      case 'pages':
        Object.entries(assignmentData[tabKey].columns).map(column => {
          let [columnKey, columnAttr] = column

          let columns = tableColumns[tabKey] || [
            <th key={'label'} style={{ textAlign: 'left' }}>
              {assignmentData[tabKey].label}
            </th>
          ]
          return (tableColumns = {
            ...tableColumns,
            [tabKey]: [...columns, <th key={columnKey}>{columnAttr.label}</th>]
          })
        })

        data = Object.entries(assignmentData[tabKey].data).map(tabData => {
          let [dataKey, dataAttr] = tabData
          let firstColumn = (
            <td style={{ textAlign: 'left' }}>
              {translate(dataAttr.page_name) || dataAttr.page_name}
            </td>
          )
          let dataColumns = Object.entries(assignmentData[tabKey].columns).map(column => {
            let [columnKey, columnAttr] = column
            let inputElement = null

            inputElement = (
              <InputGroup
                inputValue={!!dataAttr[columnKey]}
                inputType={columnAttr.inputType}
                changed={e => inputChanged(dataKey, columnKey, columnAttr.inputType, { ...e })}
                groupClass={classes.InputItem}
                inputClass={classes.Checkbox}
                noMargin
                style={{ margin: 0 }}
              />
            )

            return <td key={`${dataKey + columnKey}`}>{inputElement}</td>
          })
          return (
            <tr key={dataKey}>
              {firstColumn}
              {dataColumns}
            </tr>
          )
        })
        tabContent = (
          <table className={classes.Table}>
            <thead>
              <tr>{tableColumns[tabKey]}</tr>
            </thead>
            <tbody>{data}</tbody>
          </table>
        )
        tabContents.push({
          key: tabKey,
          display: tabContent
        })
        break
      case 'users':
        forms = Object.entries(assignmentData[tabKey].data).map(formItem => {
          let [formKey, formAttr] = formItem
          return (
            <InputGroup
              key={formKey}
              configs={formAttr.elementConfig}
              label={formAttr.label}
              inputValue={formAttr.value}
              inputType={formAttr.inputType}
              changed={e => inputChanged(formKey, null, formAttr.inputType, e)}
              invalid={!formAttr.valid}
              validations={formAttr.validation}
              touched={formAttr.touched}
              validationError={formAttr.error}
            />
          )
        })
        tabContent = forms
        tabContents.push({
          key: tabKey,
          display: tabContent
        })
        break
      default:
        break
    }

    return { label: tabAttr.label, key: tabKey }
  })

  let assignBody = <Spinner />
  if (!loading) {
    assignBody = (
      <FullWidthTabs
        variant={'fullWidth'}
        tabs={tabs}
        currentTabIndex={currentTabIndex}
        tabChanged={tabChanged}
        tabContents={tabContents}
      />
    )
  }

  // Cancelled disabled save button check
  const assignActions = (
    <div className={classes.ButtonGroup}>
      <span className={classes.Button}>
        <Button color={'primary'} clicked={onAssigned} disabled={!formIsValid}>
          {translate('save')}
        </Button>
      </span>
      <span className={classes.Button}>
        <Button color={'default'} clicked={cancelled}>
          {translate('cancel')}
        </Button>
      </span>
    </div>
  )
  return (
    <Modal
      size={'lg'}
      open={open}
      onHide={cancelled}
      header={translate('roleAssignment')}
      footer={assignActions}>
      {assignBody}
    </Modal>
  )
}

export default withTranslate(assignModal)
